// dialog-payloads.engine.ts
import { RowType, Reservation } from "src/app/models";

export type Flip = { id: string; rowType: RowType; newFlag: boolean };

export function buildFlipUpdatesPayload(flips: Flip[], excludeId: string) {
  return flips
    .filter((f) => f.id !== excludeId)
    .map((f) => ({
      id: f.id,
      payload:
        f.rowType === "aircraft"
          ? { secondPositionAircraft: f.newFlag }
          : { secondPositionInstructor: f.newFlag },
    }));
}

export function buildUpdateBody(args: {
  rowType?: RowType;
  startISO: string;
  endISO: string;
  secondActive?: boolean;
  secondOther?: boolean;
  aircraftId?: string | null;
  instructorId?: string | null;
  studentId?: string | null;
}) {
  const {
    rowType,
    startISO,
    endISO,
    secondActive,
    secondOther,
    aircraftId,
    instructorId,
    studentId,
  } = args;
  const body: any = {
    start: startISO,
    end: endISO,
    status: "CONFIRMED" as const,
  };
  if (rowType === "aircraft" && secondActive !== undefined)
    body.secondPositionAircraft = secondActive;
  if (rowType === "instructor" && secondActive !== undefined)
    body.secondPositionInstructor = secondActive;
  if (secondOther !== undefined) {
    if (rowType === "aircraft") body.secondPositionInstructor = secondOther;
    else body.secondPositionAircraft = secondOther;
  }
  if (aircraftId !== undefined) body.aircraftId = aircraftId;
  if (instructorId !== undefined) body.instructorId = instructorId;
  if (studentId !== undefined) body.studentId = studentId;
  return body;
}
